import { Injectable } from '@angular/core';
// import countries from "src/assets/demo/data/countries.json";

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  constructor() {
  }

  public getCountryList(): any {
    // return countries.map((country: any) => {
    //   return {
    //     key: country.name,
    //     value: country.name
    //   }
    // });
  }

  public getRandomNo(min: number = 999999999, max: number = 9999999999) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}
